import { monotonicFactory } from "ulid";
const defaultUlid = monotonicFactory();
export function generateEventId() {
    return defaultUlid();
}
export function createIdGenerator(clock) {
    // Use a deterministic PRNG so that two generators built with the same
    // pinned clock produce identical ID sequences. monotonicFactory will still
    // increment the random portion to guarantee strict ordering even when the
    // clock is frozen.
    const ulid = monotonicFactory(() => 0);
    return () => ulid(clock());
}
//# sourceMappingURL=id.js.map